import {
  LOGIN,
  LOGOUT,
  AUTHENTICATION_ERROR,
  SET_USER_DATA,
  SET_BUNDLE,
} from '../types';

const initialState = {
  isLoggedIn: false,
  isLoggingIn: true,
  isLoggingOut: false,
  error: undefined, // Error message
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        isLoggingIn: false,
      };
    case LOGOUT:
      return {
        ...initialState,
      };

    case AUTHENTICATION_ERROR:
      return {
        ...initialState,
        error: action.error,
        isLoggedIn: false,
      };

    case SET_USER_DATA:
      return {
        ...state,
        roles: action.user.roles,
        emails: action.user.emails,
        firstName: action.user.firstName,
        lastName: action.user.lastName,
        organisations: action.user.organisations,
        bundles: action.user.bundles,
        bundleName: action.user.bundleName,
        bundle: action.user.bundle,
        isAdmin: action.user.isAdmin,
        token: action.user.token,
        userId: action.user.userId,
        email: action.user.email,
        isChaseAcademy: action.user.isChaseAcademy,
      };

    case SET_BUNDLE:
      return {
        ...state,
        bundleName: action.data.bundleName,
        bundle: action.data.bundle,
      };

    default:
      return state;
  }
};
